import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import PendenciaService from '@services/PendenciaService';

const useStatusPendencia = () => {
    const fetch = useCallback(() => PendenciaService.listarStatus(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useStatusPendencia;